module.exports = __webpack_public_path__ + "img/gsb-logo.ae73fdf3.png";